import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { createPluginState } from './plugin-factory';
import { rovoAgentsPluginKey } from './plugin-key';
export function createRovoAgentsPlugin(options) {
  return new SafePlugin({
    key: rovoAgentsPluginKey,
    state: createPluginState(options.dispatch,
    // Initial state
    {
      agents: [],
      enabled: false,
      publish: function publish() {},
      isBrowseModalOpen: false,
      positions: undefined
    })
  });
}